
const ORDER_LIST_UPDATE_LIST= 'ORDER_LIST_UPDATE_LIST';
const ORDER_LIST_UPDATE_CONDIION = 'ORDER_LIST_UPDATE_CONDIION';
const ORDER_LIST_UPDATE_PAGE = 'ORDER_LIST_UPDATE_PAGE';
const ORDER_LIST_UPDATE_COURSE_LIST = 'ORDER_LIST_UPDATE_COURSE_LIST';

const HomeHeaderModel = function() {
    const name = 'HomeHeader';
    return {
        name,
        state: {
          list: [],
          condition: {
              mchNo: '',
              orderCode: '',
              payType:'',
              payState:'',
              courseId:'',
              startTime:'',
              endTime:'',
          },
          page: {
              current: 1,
              total: 0,
              pageSize:30,
          },
        },
        selectors: (state) => {
            const currentState = state[name];
            const selectors = {
              getList: () => currentState.list,
              getCondition: () => currentState.condition,
              getPage: () => currentState.page,
              getCourseList: () => currentState.courseList
            };
            return selectors;
        },
        actions: {
          changeList: (list) => (dispatch, getState) => {
            dispatch({
                type: ORDER_LIST_UPDATE_LIST,
                list
            });
          },
          changeCondition: (key, value) => (dispatch, getState) => {
              dispatch({
                  type: ORDER_LIST_UPDATE_CONDIION,
                  key,
                  value
              });
          },
          changePage: (page) => (dispatch, getState) => {
                dispatch({
                    type: ORDER_LIST_UPDATE_PAGE,
                    page
                });
            },
            changeCourseList: (list) => (dispatch, getState) => {
                dispatch({
                    type: ORDER_LIST_UPDATE_COURSE_LIST,
                    list
                });
            },
        },
        reducers: {
          list: (state=HomeHeaderModel.state.list, action) => {
            if (action.type === ORDER_LIST_UPDATE_LIST) {
              return [...action.list];
            }
            return state;
          },
          condition: (state=HomeHeaderModel.state.condition, action) => {
                if (action.type === ORDER_LIST_UPDATE_CONDIION) {
                  const { key, value } = action;
                  let obj = {};
                  obj[key] = value;
                  return Object.assign({}, state, obj);
                }
                return state;
          },
          page: (state=HomeHeaderModel.state.page, action) => {
            if (action.type === ORDER_LIST_UPDATE_PAGE) {
              return Object.assign({}, state, action.page);
            }
            return state;
          },
        }
    };
}();

export default HomeHeaderModel;


// WEBPACK FOOTER //
// ./src/models/HomeHeaderModel.js